import {
  required,
  requiredUnless,
  email,
  integer,
  minValue
} from 'vuelidate/lib/validators';

import rcc from './rcc';
import iban from './iban';
import postalAccount from './postAccount';

export default {
  company: {},
  givenName: { requiredUnless: requiredUnless('company') },
  familyName: { requiredUnless: requiredUnless('company') },
  rccNumber: { required, rcc },
  email: { email },
  addressStreet: { required },
  postalCode: { required },
  addressLocality: { required },
  iban: { iban },
  postalAccount: { postalAccount },
  paymentDelay: { required, integer, minValue: minValue(0) }
};
